module.exports = __webpack_public_path__ + "img/make-payment.d78f2be7.jpeg";